import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {EventBusService} from "../../../base/services/eventbus/event-bus.service";
import {BaseComponent} from "../../../base/components/base.component";
import {SubscriptionContainerService} from "../../../base/services/subscription-container.service";
import {AuthService} from "../../../modules/common/modules/auth/services/auth.service";
import {NotifierService} from "../../../base/services/notifier/notifier.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {
  constructor(private authService: AuthService,
              private notifier: NotifierService,
              private route: ActivatedRoute,
              eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
  ) {
    super(eventBus, router, subContainer)
  }

  protected componentName(): string {
    return LoginComponent.name;
  }

  ngOnInit(): void {
    this.startAuthorization()
  }


  startAuthorization(): void {
    const returnUrl = this.resolveReturnUrl();

    if (this.authService.isAuthenticated()) {
      this.navigateByUrl(returnUrl, () => {
      })
    } else {
      this.authService.login(returnUrl).catch(() => {
        this.notifier.error("Login Failed", "Unable to start Keycloak login flow.");
      });
    }
  }

  private resolveReturnUrl(): string {
    const fallback = '/dash/dashboard';
    const rawValue = this.route.snapshot.queryParamMap.get('returnUrl');

    if (!rawValue || !rawValue.startsWith('/')) {
      return fallback;
    }

    if (rawValue.startsWith('/auth/')) {
      return fallback;
    }

    return rawValue;
  }
}
